import styled from 'styled-components';
import theme from 'themes';

const ModalHeader = styled.div`
  padding: 1rem;
  .divider {
    margin-top: 1rem;
    border-bottom: 1px solid ${theme.colors.lightGrey3};
  }
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;
  margin-top: 0.625rem;
`;

const Content = styled.div`
  margin-top: 0.625rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const SmallText = styled.small`
  display: flex;
  > span {
    margin-left: 0.25rem;
    color: ${theme.colors.lightGrey8};
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 0.879rem;
    margin-bottom: 12.5rem;
  }
`;

const ButtonBox = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  justify-content: flex-end;
`;

const FormControlDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  text-align: left;
  flex: 1 1 45%;
  min-width: 200px;
`;

const LabelField = styled.label`
  font-weight: 500;
  margin-bottom: 4px;
`;

const InputField = styled.input`
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid ${theme.colors.lightGrey3};
  border-radius: 4px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

const TagTable = styled.table`
  width: 100%;
  border-spacing: 0 0.5rem;
  border-collapse: separate;
  margin-bottom: 1rem;
  border: 1px solid ${theme.colors.lightGrey3};
  border-radius: 8px;
  overflow: hidden;
`;

const TagTableHeader = styled.thead``;

const TagTableHeaderCell = styled.th`
  text-align: left;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.625rem 0.5rem;
  border-bottom: 1px solid ${theme.colors.lightGrey3};
`;

const TagTableBody = styled.tbody``;

const TagTableRow = styled.tr`
  &:not(:last-child) td {
    border-bottom: 1px solid ${theme.colors.lightGrey3};
  }
`;

const TagTableCell = styled.td`
  padding: 0.25rem;
`;

export {
  ModalContainer,
  ModalHeader,
  Content,
  SmallText,
  ButtonBox,
  FormGroup,
  FormControlDiv,
  LabelField,
  InputField,
  FormRow,
  TagTable,
  TagTableHeader,
  TagTableHeaderCell,
  TagTableBody,
  TagTableRow,
  TagTableCell
};
